<template>
<div>
    <confirm
    model_name="current_acount"
    :text="delete_text"
    :actions="actions"
    show_compensar_caja_checkbox
    @confirmed_final="model_deleted"
    id="delete-current-acount"
    toast="Cuenta corriente eliminada"></confirm>
    
    <confirm-afip-tickets></confirm-afip-tickets>
    <send-afip-tickets></send-afip-tickets>
    
    <update-prices></update-prices>

    <unidades-entregadas></unidades-entregadas>
    <acopio-article-deliveries></acopio-article-deliveries>

    <pago></pago>    
    <nota-credito></nota-credito>    
    <nota-debito></nota-debito>    
    <import></import>    
    <saldo-inicial></saldo-inicial>    
    <checks-details></checks-details>    
    <payment-methods-details></payment-methods-details>  
    <pagado-por></pagado-por>  

    <model-index
    :show_btn_remove_belongs_to_many="false"
    model_name="budget">
        <template v-slot:model_modal_header="props">
            <budget-modal-buttons></budget-modal-buttons>
        </template>

        <template v-slot:actualizar_en_vender="props">
            <btn-actualizar-en-vender></btn-actualizar-en-vender>
        </template>
        
    </model-index>  

    <model-index
    model_name="order_production">
        <template v-slot:default="props">
            <order-production-modal-buttons></order-production-modal-buttons>
        </template>
    </model-index>  

    <model-index
    model_name="provider_order"></model-index>  

    <sale-modal></sale-modal>

    <b-modal 
    id="current-acounts" 
    ref="current_acounts"
    :title="title" 
    hide-footer 
    size="xl" 
    body-class="p-0">
        <current-acounts-nav></current-acounts-nav>
        <!-- <color-info></color-info> -->
        <list></list>
        <btn-pago-nota-credito></btn-pago-nota-credito>
    </b-modal>
</div>
</template>
<script>
import current_acounts from '@/mixins/current_acounts'
// Modals
import Confirm from '@/common-vue/components/Confirm.vue' 
import Pago from '@/components/common/current-acounts/pago/Index'
import NotaCredito from '@/components/common/current-acounts/NotaCredito.vue'
import NotaDebito from '@/components/common/current-acounts/NotaDebito.vue'
import Import from '@/components/common/current-acounts/Import.vue'
import SaldoInicial from '@/components/common/current-acounts/SaldoInicial.vue'
import ChecksDetails from '@/components/common/current-acounts/ChecksDetails.vue'
import PaymentMethodsDetails from '@/components/common/current-acounts/payment-methods-details/Index'
import PagadoPor from '@/components/common/current-acounts/pagado-por/Index'
// import PrintBudget from '@/components/produccion/modals/budgets/Print'
import Model from '@/common-vue/components/model/Index'

// Components
// import BudgetModalButtons from '@/components/presupuestos/components/ModalButtons'
// import OrderProductionModalButtons from '@/components/produccion/components/order-productions/ModalButtons'
import CurrentAcountsNav from '@/components/common/current-acounts/Nav'
import ColorInfo from '@/components/common/current-acounts/ColorInfo'
import List from '@/components/common/current-acounts/List'
import BtnPagoNotaCredito from '@/components/common/current-acounts/BtnPagoNotaCredito'
export default {
    name: 'CurrentAcountIndex',
    mixins: [current_acounts],
    components: {
        // Modals
        Confirm,
        Pago, 
        NotaCredito,
        NotaDebito,
        Import,
        SaldoInicial,
        ChecksDetails,
        PaymentMethodsDetails,
        PagadoPor,
        // PrintBudget,
        Model,
        
        // Components
        // BudgetModalButtons,
        // OrderProductionModalButtons,
        CurrentAcountsNav,
        ColorInfo,
        List,
        BtnPagoNotaCredito,
        ModelIndex: () => import('@/common-vue/components/model/Index'),
        SaleDetails: () => import('@/components/ventas/modals/details/Index'),
        BudgetModalButtons: () => import('@/components/budget/components/ModalButtons'),
        OrderProductionModalButtons: () => import('@/components/produccion/components/order-productions/ModalButtons'),
        SaleModal: () => import('@/components/common/SaleModal'),
        ConfirmAfipTickets: () => import('@/components/ventas/modals/afip-ticket/ConfirmAfipTickets'),
        SendAfipTickets: () => import('@/components/ventas/modals/afip-ticket/SendAfipTickets'),
        BtnActualizarEnVender: () => import('@/components/budget/components/BtnActualizarEnVender'),
        UpdatePrices: () => import('@/components/ventas/modals/update-prices/Index'),
        UnidadesEntregadas: () => import('@/components/ventas/modals/unidades-entregadas/Index'),
        AcopioArticleDeliveries: () => import('@/components/ventas/modals/unidades-entregadas/AcopioArticleDeliveries'),
    },
    computed: {
        title() {
            if (this.from_model) {
                let moneda = this.get_store_model('moneda', this.from_credit_account.moneda_id)
                if (moneda) {
                    return `Cuenta corriente en  de ${this.from_model.name} (${moneda.name})`
                }
            }
            return ''
        },
        delete() {
            return this.$store.state.current_acount.delete
        },
        delete_text() {
            if (this.delete) {
                return 'este cuenta con saldo de $'+this.delete.saldo
            }
            return ''
        },
        actions() {
            return [
                'current_acount/delete',
                'current_acount/getModels',
            ]
        },
    },
    methods: {
        model_deleted() {
            this.loadModel(this.from_model_name, this.from_model.id)
        }
    }
}
</script>
<style lang="sass">
.detalle
    max-width: 100px
</style>
